﻿import { TitlePassword } from "./TitlePassword";

export default TitlePassword;
export * from "./TitlePassword";
export * from "./TitlePasswordTypes";
